export default function FormFieldSelect({ formUtility, field, label, description, options, className, classNameControl, disabled = false }) {
    return (
        <div className={className ?? "form-group"} >
            {label?.toString()?.trim().length > 0 ? <label>{label.toString().trim()}</label> : null}
            <select
                name={field}
                onChange={formUtility.handleChangeControl}
                readOnly={formUtility.fieldsDisabled || disabled}
                disabled={formUtility.fieldsDisabled || disabled}
                className={classNameControl ?? "form-control"}>
                {
                    options.map(x =>
                        <option value={x.value} selected={formUtility.getFieldValue(field) === x.value.toString()}>{x.name}</option>
                    )
                }
            </select>
            {description?.toString()?.trim().length > 0 ? <p>{description.toString().trim()}</p> : <br />}
        </div>
    );
}